
import { Component, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';

import DialogImgLarge from '@/components/ImgLarge/index.vue';
import SelectParts from '../order/components/OrderParts.vue';
import SelectPartsNew from '../order/components/OrderPartsNew.vue';
import OrderTag from '../order/components/OrderTag.vue';
import OrderBrand from '../order/components/OrderBrand.vue';
import OrderDevice from '@/components/DeviceSelectDialog/index.vue';
import InputDialog from '@/components/InputDialog/InputDialog.vue';
import WorkTimeDialog from '@/components/WorkTimeDialog/index.vue';
import SelectFaultDialog from '@/components/SelectFaultDialog/index.vue';
import SupplementProgressDialog from '@/components/SupplementProgressDialog/index.vue';
import BbsDialog from '@/components/BbsDialog/index.vue';
import TaskProcessDialog from '@/views/task/components/TaskProcessDialog .vue';
import EditDialog from '@/components/EditDialog/index.vue';
import DialogDeviceRecord from "@/views/device/components/DeviceRecord.vue";
import OrderInfo from '@/components/OrderInfo/OrderInfo.vue'
import { getOrderTaskDetail, taskFinish, orderTaskCheck, taskSendReceive, orderTaskAppear, orderPause } from '@/api/orderTask';
import { getPriceList } from '@/api/other';
import { addImage, addPrice, addRemark, addVideo, addWord, deleteDevice, deleteFault, deleteImage, deleteParts, deletePrice, deleteProduct, deleteRemark, deleteWorkTime , deleteVideo, deleteWord, handleTags } from '@/api/order';

import { makeKey } from '@/utils/qiniu';
import { imageType } from '@/types/imageType';
import { remarkType } from '@/types/remarkType';
import { limit } from '@/types/limit';
import { addNum, isEmpty, mulNum, parseTime } from '@/utils';
import { getModelPermission, checkTaskAppointmentTimeIsMust,checkPermissionCompany, checkPermissionCompanyFromOrderType, checkPermissionRole, checkPermissionUseAndCompany ,checkServerAppointmentTime} from '@/utils/permission';
import { ModuleType, ViewType, Type } from '../../types/permissionType';
import OrderArea from '../order/components/OrderArea.vue';
import { Loading } from 'element-ui';
import { LoadingServiceOptions } from 'element-ui/types/loading';
import { addAppointmentTime, diyContent, getOrderDispose, getOrderServiceProgressList } from '@/api/orderService';
import { bottomBtnTaskState, isFinish } from '@/utils/orderStatsUtils';
import BenzAMRRecorder from 'benz-amr-recorder';
import { getTaskEnquiry } from '@/api/orderTaskEnquiry';

@Component({
  name: 'TaskTodealNew',
  components: {
    DialogImgLarge,
    OrderTag,
    OrderBrand,
    OrderDevice,
    OrderArea,
    InputDialog,
    WorkTimeDialog,
    SelectFaultDialog,
    SupplementProgressDialog,
    BbsDialog,
    TaskProcessDialog,
    EditDialog,
    DialogDeviceRecord,
    OrderInfo
  },
  filters: {
    getOrderTaskDealType(value: any) {
      switch (parseInt(value)) {
        case 1:
          value = '远程';
          break;
        case 2:
          value = '上门';
          break;
        case 3:
          value = '寄修';
          break;
        case 4:
          value = '转单';
          break;
        case 5:
          value = '送修';
          break;
        default:
          value = '未处理';
          break;
      }
      return value;
    },
    getAppointmentime(val: any) {
      if (val && val.length > 0) {
        if ('appointment_time' in val[0]) {
          return val[0].appointment_time;
        } else {
          return '暂无';
        }
      } else {
        return '暂无';
      }
    },
    getArraignmentState(value: any) {
      switch (parseInt(value)) {
        case 0:
          value = '未处理';
          break;
        case 1:
          value = '审批通过';
          break;
        case 3:
          value = '审批不通过';
          break;
        case 5:
          value = '审批关闭';
          break;
      }
      return value;
    }
  }
})
export default class extends Vue {
  // 公司是否开启新版备件
  private get currentParts() {
    const company: any = UserModule.getCompany;
    return company && company.is_new_spare_parts && parseInt(company.is_new_spare_parts) === 1
      ? SelectPartsNew
      : SelectParts;
  }
  private limit:any = limit;

  private appointmenTimeMust=false;
  private formInformation: any = {
    appointment: '',
    expedited: false,
    tag: '',
    tags: [],
    brand: [],
    device: [],
    parts: [],
    image: [],
    video: [],
    word: [],

    evaluate: '',

    costType: '',
    costValue: '',
    remark: '',
    order_task_list: []
  }
  private dynamicRemark:any = []
  private dynamicFault:any = []
  private dynamicPhenomenon:any = []
  private dynamicCost:any = []
  private costList:any = []
  private partsVisible = false
  private tagVisible =false
  private deviceVisible = false

  private companyId :any= '';
  private taskId:any = '';
  private orderType :any = '';
  private enterType:any = ''; // 1 立即处理 2 协同处理 3 追加信息 4 任务完成
  private isDetail:any=false;
  private isProgress:any=false;

  private taskDetail: any = {
    order: {},
    order_service: {},
    order_task: {}
  };
  private modulesHandlePer: any = {};

  private isFinish=false
  private orderState:number = 0;
  private confirmButton = false;
  private topButtonList:any=[];
  private orderProgressData:any = {};
  private activeLeft = 'infor';
  private activeRight = 'infor';
  private dynamicOrderSend:any=[];
  private isShowDeviceHistry: boolean=false;
  private isAddAddedProgress: boolean=false;
  private isShowAddedProgress: boolean=false;
 

  private workSheetHandle() {
    window.open(
      location.protocol + (process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_BASE_API_DEV) + 'OrderService/workSheetDetail?company_id=' + UserModule.getCompanyId + '&user_id=' + UserModule.getUserId + '&user_name=' + UserModule.getUserName + '&company_name=' + UserModule.getCompanyName + '&order_service_id=' + this.taskDetail.order_service.id
    );
  }
  private isWorksheet = false

  private editDialogData: any = {
    visible: false,
    title: '',
    name: '',
    inputValue: '',
    inputHint: '',
    cancel: '',
    confirm: '',
    callBack: '',
    rules: []
  };

  private isSelf(userId: any){
    return parseInt(UserModule.getUserId) === parseInt(userId);
  }

  private referesh() {
    this.getTaskDetail();
    this.configPermission();
  }

  private created() {
    this.companyId = this.$route.query.companyId;
    this.taskId = this.$route.query.taskId;
    this.orderType = this.$route.query.orderType;
    this.enterType = this.$route.query.enterType;
    this.isDetail = parseInt(this.$route.query.isDetail as string) === 1;
    this.isProgress = parseInt(this.$route.query.isProgress as string) === 1;

    this.isShowDeviceHistry = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.DeviceHistry);
    this.isModifyOtherPrice = parseInt((UserModule.getCompany as any).is_modify_other_price) === 1;
    this.isAddAddedProgress = checkPermissionCompany(UserModule.getCompanyId, Type.TemplateAddedProgressTags);
    this.isShowAddedProgress = checkPermissionCompany(UserModule.getCompanyId, Type.TemplateAddedProgressTags);

    this.getTaskDetail();
    this.configPermission();
  }
  private getTagsHtml(r: any) {
    let kind = "";
    let kindType = "";
    let abnormal = "";
    let plain = "plain";
    if (parseInt(r.order.order_type) === 1) {
      kind = "其他";
      kindType = "warning";
    } else if (parseInt(r.order.order_type) === 2) {
      kind = "维保";
      kindType = "success";
    } else if (parseInt(r.order.order_type) === 3) {
      kind = "安装";
      kindType = "danger";
    } else if (parseInt(r.order.order_type) === 4) {
      kind = "巡检";
      kindType = "";
      if (parseInt(r.order_service.polling_check_abnormal_count) > 0) {
        abnormal = "巡异";
      }
    } else {
      kind = "维保";
      kindType = "success";
    }

    let source = "";
    if (r.order.customer_company_id === r.order_service.servicer_company_id) {
      source = "内部";
    } else {
      source = "外部";
    }
    if (parseInt(r.order_service.transfer_in) === 1) {
      source = "转入";
    }
    if (parseInt(r.order_service.transfer_out) === 1) {
      source = "转出";
    }

    let charge = "";
    let darkplain = "dark";
    if (parseInt(r.order_service.charge) === 1) {
      charge = "收费";
    }

    let expedited = "";
    if (parseInt(r.order_service.expedited) === 1) {
      expedited = "加急";
    }

    // 2019-05-23 迭代 订单排位
    let ranking = "";
    if (parseInt(r.order_service.is_ranking) === 1) {
      let rankingNum = parseInt(r.order_service.ranking);
      if (rankingNum) {
        ranking = rankingNum + "号";
      }
    }

    // 审核标识
    let check = "";
    if (
      parseInt(r.order.check_state) === 11 ||
      parseInt(r.order.check_state) === 51
    ) {
      check = "审核";
    }

    // 留言
    let mesg = "";
    if (r.order.new_bbs_content && r.order.new_bbs_content.id) {
      mesg = "have";
    }

    if (r.order.is_new_bbs) {
      mesg = "new";
    }

    let urgent = ''
    if (r.order.reminder && parseInt(r.order.reminder.count) > 0) {
      urgent = '已催单' + r.order.reminder.count + '次'
    }

    return [
      {
        type: "",
        label: source,
        plain: darkplain,
      },
      {
        type: kindType,
        label: kind,
        plain: plain,
      },
      {
        type: "danger",
        label: abnormal,
        plain: darkplain,
      },
      {
        type: "danger",
        label: charge,
        plain: darkplain,
      },
      {
        type: "danger",
        label: expedited,
        plain: darkplain,
      },
      {
        type: "danger",
        label: ranking,
        plain: darkplain,
      },
      {
        type: "warning",
        label: check,
        plain: darkplain,
      }, {
        type: "warning",
        label: urgent,
        plain: plain,
      }
    ];
  }
  private handleCustomerClick(tab: any, event: any) {
    switch (tab.name) {
      case 'schedule':
        this.getProgressList()
        break;
    }
  }
  private handleServicerClick(tab: any, event: any) {
    switch (tab.name) {
      case 'schedule':
        this.getProgressList()
        break;
    }
  }
  private supplementProgressDialogVisible: boolean = false;
  private supplementProgress() {
    this.supplementProgressDialogVisible = true;
  }
  SupplementProgressDialogClose(isRefresh:boolean) {
    this.supplementProgressDialogVisible = false;
    if (isRefresh) {
      this.getProgressList()
    }
  }
  private customerRecordHandle() {
    let cus:any = {
      company_id: this.taskDetail.order.customer_company_id,
      user_id: this.taskDetail.order.customer_user_id,
      customer_type: this.taskDetail.order.customer_type,
    }
    let routeData = this.$router.resolve({
      path: '/Record/list',
      query: cus
    });
    window.open(routeData.href);
  }

  private totleParts = 0
  private totlePrice = 0
  private getSummariesParts(param: any) {
    const { columns, data } = param;
    const sums: any = [];
    let realIndex = 0
    if (this.formInformation.parts && this.formInformation.parts.length > 0) {
      columns.forEach((column: any, index: any) => {
        if (index === 0) {
          sums[index] = '备件总金额（合计：';
          return;
        }
        if (data && data.length > 0) {
          const values = data.map((item: any) => Number(item[column.property]));
          if (values) {
            sums[index] = values.reduce((prev: any, curr: any) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return addNum(prev,curr);
              } else {
                return prev;
              }
            }, 0);
          }
        }

        if (column.property === 'parts_price') {
          realIndex = index
          sums[index] = parseFloat(sums[index]).toFixed(2)
        }
        this.totleParts = sums[realIndex]
        sums[0] = '备件总金额（合计：' + sums[realIndex] + ' 元）';
      });
    } else {
      this.totleParts = 0
      sums[0] = '备件总金额（合计：' + 0 + ' 元）';
    }
    return sums;
  }
  @Watch('formInformation.parts', {
    deep: true,
    immediate: true
  })
  summaryParts() {
    if (this.formInformation.parts && this.formInformation.parts.length > 0) {
      this.$nextTick(() => {
        const tds: any = document.querySelectorAll('#table-parts .el-table__footer-wrapper tr>td');
        tds[0].colSpan = 8
        tds[1].style.display = 'none'
        tds[2].style.display = 'none'
        tds[3].style.display = 'none'
        tds[4].style.display = 'none'
        tds[5].style.display = 'none'
        tds[6].style.display = 'none'
        tds[7].style.display = 'none'
      })
    }
  }

  private getSummariesPrice(param: any) {
    const { columns, data } = param;
    const sums: any = [];
    let realIndex = 0
    if (this.dynamicCost && this.dynamicCost.length > 0) {
      columns.forEach((column: any, index: any) => {
        if (data && data.length > 0) {
          const values = data.map((item: any) => Number(item[column.property]));
          if (values) {
            sums[index] = values.reduce((prev: any, curr: any) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return addNum(prev,curr);
              } else {
                return prev;
              }
            }, 0);
            if (column.property === 'price_num') {
              realIndex = index
              sums[index] = parseFloat(sums[index]).toFixed(2)
            }
            this.totlePrice = sums[realIndex]
            sums[0] = '总费用（合计：' + sums[realIndex] + ' 元）';
          }
        }
      });
    } else {
      this.totlePrice = 0;
      sums[0] = '总费用（合计：' + 0 + ' 元）';
    }
    return sums;
  }
  @Watch('dynamicCost', {
    deep: true,
    immediate: true
  })
  summaryPrice() {
    if (this.dynamicCost && this.dynamicCost.length > 0) {
      this.$nextTick(() => {
        const tds: any = document.querySelectorAll('#table-price .el-table__footer-wrapper tr>td');
        tds[0].colSpan = 3
        tds[1].style.display = 'none'
        tds[2].style.display = 'none'
      })
    }
  }

  private configPermission() {
    // 九大模块处理  相关处理权限
    this.modulePerHandle();
  }

  // 九大模块的权限判断
  private modulePerHandle() {
    let tag = this.setPermissionWithType(ModuleType.ORDER_TAG);
    let brand = this.setPermissionWithType(ModuleType.ORDER_PRODUCT);
    let device = this.setPermissionWithType(ModuleType.ORDER_DEVICE);
    let part = this.setPermissionWithType(ModuleType.ORDER_PARTS);
    let img = this.setPermissionWithType(ModuleType.ORDER_DEAL_IMAGE);
    let video = this.setPermissionWithType(ModuleType.ORDER_DEAL_VIDEO);
    let fee = this.setPermissionWithType(ModuleType.ORDER_COST);
    let fault = this.setPermissionWithType(ModuleType.ORDER_FAULTTYPE);
    let phenomenon = this.setPermissionWithType(ModuleType.ORDER_FAULTPHENOMENON);
    let deviceSn = this.setPermissionWithType(ModuleType.ORDER_SN);
    let appointmenTime= this.setPermissionWithType(ModuleType.ORDER_APPOINTMENT_TIME);
    let workTime = this.setPermissionWithType(ModuleType.ORDER_WORKTIME);
    let remark = this.setPermissionWithType(ModuleType.ORDER_REMARK);
    let fixSummary = this.setPermissionWithType(ModuleType.ORDER_FIX_SUMMARY);

    let diyOne = this.setPermissionWithType(ModuleType.ORDER_DIY_ONE);
    let diyTwo = this.setPermissionWithType(ModuleType.ORDER_DIY_TWO);
    let word = this.setPermissionWithType(ModuleType.ORDER_WORD_FILE);

    this.modulesHandlePer = {
      'tag': tag,
      'brand': brand,
      'device': device,
      'part': part,
      'img': img,
      'video': video,
      'fee': fee,
      'fault': fault,
      'phenomenon': phenomenon,
      'deviceSn': deviceSn,
      'remark': remark,
      'fixSummary': fixSummary,
      'appointmentTime': appointmenTime,
      'workTime': workTime,
      'diyOne': diyOne,
      'diyTwo': diyTwo,
      'word': word
    };
  }

  private setPermissionWithType(moduleType: ModuleType) {
    return getModelPermission(ViewType.DEAL_TASK, this.orderType, 0, this.companyId, moduleType);
  }
  private selectedTaskProcessVisible=false;

  private dealTaskHandle() {
    this.selectedTaskProcessVisible = true
  }
  private closeTaskProcessDialog(val:any, isReferesh:any) {
    this.selectedTaskProcessVisible = val;
    if (typeof isReferesh !== 'function' && isReferesh) {
      this.backToTaskList();
    }
  }
  private selectedOrderProcessData(disposeNext:any) {
    this.selectedTaskProcessVisible = false;
    if (disposeNext) {
      this.handleNextTask(disposeNext)
    } else {
      this.backToTaskList();
    }
  }
  // 留言
  private bbsState: any='';
  private nowId: number = -1;
  private nowSid: number = -1;
  private nowTid: number = -1;
  private bbsDialogVisible: boolean = false;
  bbsHandle(r: any) {
    this.bbsState = parseInt(this.taskDetail.order.state);
    this.nowId = parseInt(r.order.id);
    this.nowSid = parseInt(r.order_service.id);
    this.nowTid = parseInt(r.order_task.id);
    this.bbsDialogVisible = true;
  }
  closeBbs(value: boolean) {
    this.getTaskDetail()
    this.bbsDialogVisible = value;
  }
  /**
   *  任务 服务完成
  */

  private taskFinishClick() {
    if (this.needCheckTask()) {
      this.handleCheck();
      return;
    }
    if (!this.judgeMoudlesInputInfo()) {
      return;
    }
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: (this.taskDetail as any).order_task.id,
      fix_summary: this.formInformation.fixSum,
      is_quote_order: '0' // 生成报价单
    };
    taskFinish(params).then(res => {
      this.showSuccessMsg('服务完成');
      setTimeout(() => {
        this.backToTaskList();
      }, 0.8 * 1000);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 预约时间添加
  private appointmentChange(val:any) {
    let pamars:any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      order_service_id: this.taskDetail.order_service.id,
      order_id: this.taskDetail.order.id,
      servicer_appointment_time: val / 1000 };
    addAppointmentTime(pamars).then(res => {
      this.getTaskDetail();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // 点击继续处理下一个任务
  private handleNextTask(val: any) {
    this.$confirm('要继续处理下一个任务吗?', '提示', {
      confirmButtonText: '继续处理',
      cancelButtonText: '取消',
      showClose: false,
      type: 'info'
    }).then(() => {
      let option : LoadingServiceOptions = { text: '加载中' };
      let loadingInstance = Loading.service(option);
      setTimeout(() => {
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          this.companyId = val.company_id;
          this.taskId = val.id;
          this.orderType = val.order_type;
          this.enterType = '1';
          this.getTaskDetail();
          this.configPermission();
          loadingInstance.close();
        });
      }, 1 * 1000);
    }).catch(() => {
      this.backToTaskList();
    });
  }

  // 点击返回 返回到任务列表
  private backToTaskList() {
    this.$router.go(-1);
  }
  private clickDocument(val: any) {
    const url = val.full_path;
    const filename = val.original_name;
    let arr = ['pdf', 'html'];
    let nameArr = filename.split('.');
    if (arr.includes(nameArr[1])) {
      window.open(url);
    } else {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = new Blob([this.response]);
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        }
      };
      xhr.send();
    }
  }
  private voiceHandle(val: any, index: number) {
    let _this = this;
    let amr = new BenzAMRRecorder();

    for (let i = 0; i < val.length; i++) {
      if (i === index) {
        val[i].isPlaying = true;
      }
      val[i].isPlaying = false;
    }

    amr.initWithUrl(val[index].full_path).then(function() {
      val[index].isPlaying = true;
      amr.play();
      _this.$set(val, index, val[index]);
    });

    amr.onEnded(function() {
      amr.stop();
      val[index].isPlaying = false;
      _this.$set(val, index, val[index]);
    });
  }
  // 获取任务详情
  private getTaskDetail() {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId
    };
    getOrderTaskDetail(params).then(res => {
      const data = res.data;
      if (res.data) {
        this.taskDetail = res.data;
        this.qiniu = this.taskDetail.uptoken;
        if (this.taskDetail.order.parts_list) {
          for (var bean of this.taskDetail.order.parts_list) {
            bean.str =
                this.isNull(bean.parts_name) +
                '/' +
                this.isNull(bean.parts_model_name) +
                '/' +
                this.isNull(bean.parts_amount) +
                '/' +
                this.isNull(bean.parts_unit_price) +
                '/' +
                this.isNull(bean.parts_price) +
                '/' +
                this.isNull(bean.parts_attribute_name);
          }
        }
        if (this.taskDetail.order_service.video_list) {
          for (var bean2 of this.taskDetail.order_service.video_list) {
            bean2.img_url = bean2.full_path;
          }
        }
        this.dynamicCost = this.taskDetail.order.order_price;
        this.dynamicFault = this.taskDetail.order.fault_list;
        this.dynamicPhenomenon = this.taskDetail.order.fault_phenomenon_list;
        this.dynamicRemark = this.taskDetail.order.order_remark;

        if (this.taskDetail.order.order_task) {
          this.taskDetail.order.order_task.forEach((element:any) => {
            if (!this.dynamicRemark) {
              this.dynamicRemark = []
            }
            this.dynamicRemark.push({
              classify_name: '',
              remark: "【维修小结】" + element.fix_summary,
              addtime: element.finish_time,
              user_name: element.user_name })
          });
        }
        // 寄修信息
        if (this.taskDetail.order_task && this.taskDetail.order_task.order_send) {
          let outsend = {
            type: '1',
            title: '寄出信息',
            name: this.taskDetail.order_task.order_send.send_name,
            mobile: this.taskDetail.order_task.order_send.send_mobile ? this.taskDetail.order_task.order_send.send_mobile : this.taskDetail.order_task.order_send.send_phone_num,
            address: this.taskDetail.order_task.order_send.send_province_name + this.taskDetail.order_task.order_send.send_city_name + this.taskDetail.order_task.order_send.send_district_name + this.taskDetail.order_task.order_send.send_address,
            deliveryName: this.taskDetail.order_task.order_send.send_express_name,
            deliveryNumber: this.taskDetail.order_task.order_send.send_express_number
          }
          this.dynamicOrderSend.push(outsend);

          let insend = {
            title: '寄回信息',
            name: this.taskDetail.order_task.order_send.reply_name,
            mobile: this.taskDetail.order_task.order_send.reply_mobile ? this.taskDetail.order_task.order_send.reply_mobile : this.taskDetail.order_task.order_send.reply_phone_num,
            address: this.taskDetail.order_task.order_send.reply_province_name + this.taskDetail.order_task.order_send.reply_city_name + this.taskDetail.order_task.order_send.reply_district_name + this.taskDetail.order_task.order_send.reply_address,
            deliveryName: this.taskDetail.order_task.order_send.reply_express_name,
            deliveryNumber: this.taskDetail.order_task.order_send.reply_express_number
          }
          this.dynamicOrderSend.push(insend);
        }

        this.formInformation.tags = this.taskDetail.order.tags;
        this.formInformation.brand = this.taskDetail.order_service.brand_list;
        this.formInformation.device = this.taskDetail.order_service.device_list;
        this.formInformation.parts = this.taskDetail.order.parts_list;
        this.formInformation.image = this.taskDetail.order.order_image;
        this.formInformation.video = this.taskDetail.order_service.video_list;
        if (this.taskDetail.order_service.document_list) {
          this.formInformation.word = this.taskDetail.order_service.document_list;
        } else {
          this.formInformation.word = [];
        }
        if (this.formInformation.word) {
          this.formInformation.word.map(function(item:any) {
            item.name = item.original_name;
          });
        }
        this.formInformation.order_task_list = this.taskDetail.order_task_list;
        if (this.taskDetail.order_service.servicer_appointment_timestamp && parseInt(this.taskDetail.order_service.servicer_appointment_timestamp) !== 0) {
          this.formInformation.appointment = this.taskDetail.order_service.servicer_appointment_timestamp + '000';
        }
        this.$set(this.formInformation, 'expedited', parseInt(this.taskDetail.order_service.expedited) === 1);
        this.$set(this.formInformation, 'isFree', parseInt(this.taskDetail.order_service.is_charge) === 1);
        //增加预约时间模块判断 如果有 再判断任务上门的预约时间
        this.appointmenTimeMust = parseInt(this.modulesHandlePer.appointmentTime.v) !== 0 ? checkTaskAppointmentTimeIsMust(this.taskDetail.order.order_type, this.companyId) : false;
        if (!this.isDetail) {
          this.configCheck()
        }
        this.initButtonList(this.taskDetail);
        if (this.isProgress) {
          this.activeLeft = 'schedule'
          this.getProgressList()
        }
        if(parseInt(this.taskDetail.order_task.is_assign_enquiry)===1){
          this.handleEnquiry()
        }
      }
      // else {
      //   this.formInformation = {};
      // }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private initButtonList(taskDetail:any) {
    this.orderState = bottomBtnTaskState(parseInt(taskDetail.order_task.state))
    this.confirmButton = [2, 6].includes(this.orderState) && parseInt(taskDetail.order.order_type) !== 4 && parseInt(this.enterType) !== 3 && !this.isDetail;
    this.isFinish = isFinish(
      parseInt(this.taskDetail.order_task.state)
    );
    this.isWorksheet = (this.orderState >= 3) && checkPermissionCompanyFromOrderType(this.taskDetail.order_task.company_id,
      Type.ORDER_WORK_SHEET,
      this.taskDetail.order.order_type);
    this.topButtonList = [
      { id: 1,
        style: 'color: #f00',
        show: [1, 2, 3, 4, 5, 6].includes(this.orderState) && parseInt(taskDetail.order.order_type) !== 4 &&
        checkPermissionCompanyFromOrderType(taskDetail.order_task.company_id, Type.TASK_APPEAR, taskDetail.order.order_type) &&
        checkPermissionRole(taskDetail.order_task.company_id, Type.TASK_APPEAR),
        info: '上报' },
      { id: 5,
        style: 'color: #f00',
        show: [1, 2, 3, 4, 5, 6].includes(this.orderState) && parseInt(taskDetail.order.order_type) !== 4 &&
        checkPermissionCompanyFromOrderType(taskDetail.order_task.company_id, Type.PauseTask, taskDetail.order.order_type) &&
        checkPermissionRole(taskDetail.order_task.company_id, Type.PauseTask),
        info: parseInt(taskDetail.order_task.pause_last_state) === 1 ? '继续' : '暂停' },

      // { id: 2,
      //   show: [1, 2, 3, 4, 5, 6].includes(this.orderState) && parseInt(taskDetail.order.order_type) !== 4 &&
      //          checkPermissionCompanyFromOrderType(taskDetail.order_task.company_id, Type.TASK_COORDINATION, taskDetail.order.order_type),
      //   info: '协同处理' },
      { id: 3,
        show: !this.isFinish && this.orderState === 4 &&
              checkPermissionCompanyFromOrderType(taskDetail.order_task.company_id, Type.TASK_DEAL, taskDetail.order.order_type),
        info: '确认收货' },
      { id: 4,
        show: !this.isFinish && this.orderState === 5 &&
        checkPermissionCompanyFromOrderType(taskDetail.order_task.company_id, Type.TASK_DEAL, taskDetail.order.order_type),
        info: '寄回' },

    ]
  }
  private buttonClick(button:any) {
    switch (parseInt(button.id)) {
      case 1:
        this.editDialogData = {
          visible: true,
          title: '上报',
          name: '备注',
          inputValue: '',
          other: '',
          inputHint: '请填写备注',
          cancel: '取消',
          confirm: '确定',
          callBack: 'aplayTaskCallBack',
          rules: [{ required: true, message: '请填写备注', trigger: 'blur' }]
        };
        // 上报
        break;
      case 2:
        // 协同处理
        break;
      case 3:
        this.$confirm('确认收货?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning'
        }).then(() => {
          this.handleSendRecive();
        }).catch(err => {
          let msg = err.msg;
        });
        // 确认收货
        break;
      case 4:
        this.dialogSendBackVisible = true;
        // 寄回
        break;
      case 5:
        this.pauseTaskHandle(this.taskDetail)
        // 寄回
        break;
    }
  }
  // 上报
  private aplayTaskCallBack(editDialogData : any) {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      order_task_id: this.taskDetail.order_task.id,
      remark: editDialogData.inputValue
    };
    orderTaskAppear(params).then((res:any) => {
      this.showSuccessMsg('上报成功');
      this.editDialogData.visible = false;
      this.backToTaskList();
    }).catch((err:any) => {
      let msg = err.msg;
    });
  }
  // 暂停
  private pauseTaskHandle(val: any) {
    if (parseInt(val.order_task.pause_last_state) === 1) {
      this.pauseTask(false);
    } else {
      this.editDialogData = {
        visible: true,
        title: '暂停任务',
        name: '备注',
        inputValue: '',
        inputHint: '请填写备注信息',
        other: '暂停任务之后，再次处理，需继续开始该任务，否则任务无法服务完成。',
        cancel: '取消',
        confirm: '确定',
        callBack: 'pauseTaskCallBack',
        rules: [{ required: true, message: '请填写备注信息', trigger: 'blur' }]
      };
    }
  }
  private pauseTaskCallBack(editDialogData : any) {
    this.pauseTask(true);
  }

  private pauseTask(isPause:boolean) {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = this.taskDetail.order_task.company_id;
    params.order_task_id = this.taskDetail.order_task.id;
    if (this.editDialogData.inputValue) {
      params.remark = this.editDialogData.inputValue;
    }

    params.pause_state = isPause ? '1' : '2';
    orderPause(params).then((res:any) => {
      this.showSuccessMsg(res.msg);
      this.editDialogData.visible = false;
      this.backToTaskList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 确认收货
  private handleSendRecive() {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.taskDetail.order_task.company_id,
      order_task_id: this.taskDetail.order_task.id
    };
    taskSendReceive(params).then(res => {
      this.showSuccessMsg('收货成功');
      setTimeout(() => {
        this.backToTaskList();
      }, 500);
    }).catch((err) => {
      this.showErrorMsg(err.msg);
    });
  }
  /**
   * 点击寄回 完成寄修服务
   */
  private dialogSendBackVisible = false
  private formSendBack = {
    radio: '1',
    company: '',
    number: '',
    brief: ''
  }
  private sendBackConfirm() {
    if (!this.formSendBack.company) {
      this.showErrorMsg('请输入物流公司');
      return;
    }
    if (!this.formSendBack.number) {
      this.showErrorMsg('请输入物流单号');
      return;
    }
    if ((!this.formSendBack.brief || isEmpty(this.formSendBack.brief.trim())) && this.modulesHandlePer.fixSummary.m === 1) {
      this.showErrorMsg('请填写维修小结');
      return;
    }
    let that = this;
    this.$confirm('确认寄回 服务完成?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      showClose: false,
      type: 'warning'
    }).then(() => {
      that.sendBackToFinishTask();
    }).catch(err => {
      let msg = err.msg;
    });
  }

  private sendBackToFinishTask() {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.taskDetail.order_task.company_id,
      order_task_id: this.taskDetail.order_task.id,
      fix_summary: this.formSendBack.brief,
      reply_type: this.formSendBack.radio,
      reply_express_name: this.formSendBack.company,
      reply_express_number: this.formSendBack.number,
      is_quote_order: '0' // 生成报价单
    };
    taskFinish(params).then(res => {
      this.dialogSendBackVisible = false;
      this.showSuccessMsg('收货成功 任务完成');
      setTimeout(() => {
        this.backToTaskList();
      }, 500);
    }).catch((err) => {
      this.showErrorMsg(err.msg);
    });
  }

  private getProgressList() {
    let p: any = {};
    p.user_id = UserModule.getUserId;
    p.company_id = UserModule.getCompanyId;
    p.order_service_id = this.taskDetail.order_service.id;
    if (this.taskDetail.order.id) {
      p.order_id = this.taskDetail.order.id;
    }
    p.user_name = UserModule.getUserName;
    getOrderServiceProgressList(p)
      .then((res) => {
        const data = res.data;
        if (data !== null) {
          this.orderProgressData = data;
        } else {
          this.orderProgressData = {};
        }
      })
      .catch((err) => {
        let msg = err.msg;
        this.orderProgressData = {};
      });
  }
  /**
   * 审核处理
  */
  private configCheck() {
    if (this.needCheckTask()) this.handleCheck();
  }
  private needCheckTask() {
    let priceLimit = this.taskDetail.order.order_check_price_limit;
    if (priceLimit) {
      var totalPrice = 0.0;
      if (this.dynamicCost) {
        for (const item of this.dynamicCost) {
          totalPrice += parseFloat(item.price_num);
        }
      }
      if (this.formInformation.parts) {
        for (const item of this.formInformation.parts) {
          totalPrice += parseFloat(item.parts_price);
        }
      }
      if (this.taskDetail.order.check_state !== '71' && totalPrice >= parseFloat(priceLimit)) return true;
    }
    return false;
  }
  private checkModel: any = {
    remark: '',
    title: ''
  }
  private checkVisible = false;
  private handleCheck() {
    let priceLimit = this.taskDetail.order.order_check_price_limit;
    // let tip = '金额超过' + priceLimit + '元, 请提交审核';
    let tip = '您的订单金额超过限制，请提交审核！';
    this.checkVisible = true;
    this.checkModel.title = tip;
  }
  private clickToCancleCheck() {
    this.checkVisible = false;
  }
  private clickToCheck() {
    if (!this.checkModel.remark) {
      this.showErrorMsg('请填写提审备注');
      return;
    }
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      order_service_id: (this.taskDetail as any).order_service.id,
      order_check_is_price: 1,
      remark: this.checkModel.remark
    };
    orderTaskCheck(params).then(res => {
      this.showSuccessMsg('提审成功');
      setTimeout(() => {
        this.backToTaskList();
      }, 0.8 * 1000);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // =========================
  // ================九大模块处理
  // ================
  // 订单标签
  private selectTag() {
    if (this.isDetail) {
      return
    }
    if (parseInt(this.taskDetail.order.order_check_tag_is_pass) === 1) {
      if (this.$refs.inputTag) {
        (this.$refs.inputTag as any).blur();
      }
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    if (
      this.formInformation.tags &&
      this.formInformation.tags.length >= limit.ORDER_SERVICE_ADD_TAG
    ) {
      this.showErrorMsg('您最多选择' + limit.ORDER_SERVICE_ADD_TAG + '个标签');
      return;
    }
    this.tagVisible = true;
  }

  private closeTagHandle(val:boolean) {
    this.tagVisible = val;
  }

  private delTagHandle(val: any) {
    if (parseInt(this.taskDetail.order.order_check_tag_is_pass) === 1) {
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    let tags: any = [];
    tags = tags.concat(this.formInformation.tags);
    tags.splice(tags.indexOf(val), 1);
    let values: any = [];
    for (const item of tags) {
      let tag: any = {};
      tag.tags_name = item.tags_name;
      tag.tags_id = item.tags_id;
      values.push(tag);
    }
    let tagsValue = values.length > 0 ? JSON.stringify(values) : '';
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      tags: tagsValue
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    handleTags(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  private confirmTagHandle(value:any) {
    this.tagVisible = false;
    this.showSuccessMsg('操作成功');
    this.getTaskDetail();
  }

  // 品牌
  private brandVisible = false
  private selectBrandHandle() {
    this.brandVisible = true;
  }
  private closeBrandHandle(val: boolean) {
    this.brandVisible = val;
  }
  private confirmBrandHandle(val:any) {
    this.brandVisible = false;
    this.showSuccessMsg('操作成功');
    this.getTaskDetail();
  }

  private deleteBrandHandle(id: any) {
    const params: any = {
      id: id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteProduct(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private isShowDevice = false
  private toggleDeviceShow() {
    this.isShowDevice = !this.isShowDevice
  }
  // 设备选择
  private selectDeviceHandle() {
    this.deviceVisible = true;
  }
  private closeDeviceHandle(val: boolean) {
    this.deviceVisible = val;
  }

  private cleanDevice(val: any) {
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteDevice(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  private confirmDeviceHandle(value: any) {
    this.deviceVisible = false;
    this.showSuccessMsg('设备添加成功');
    // 因为没有返回新生成记录的ID  所以直接重新调用任务详情
    this.getTaskDetail();
  }
  // 设备履历
  private dialogDeviceRecordVisible = false;
  private rowData: any = "";
  private deviceRecordHandle(val: any) {
    this.rowData = val;
    this.dialogDeviceRecordVisible = true;
  }
  closeRecordHandle(value: boolean) {
    this.dialogDeviceRecordVisible = value;
  }
  // 选择备件
  private selectPartsHandle() {
    if (parseInt(this.taskDetail.order.order_check_price_is_pass) === 1) {
      if (this.$refs.inputParts) {
        (this.$refs.inputParts as any).blur();
      }
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    this.partsVisible = true;
  }
  private closeParts(val:boolean) {
    this.partsVisible = val;
  }
  private deletePartsHandle(val:any) {
    if (val.already_charge_off_num && parseInt(val.already_charge_off_num) !== 0) {
      this.showErrorMsg('备件已核销不能删除');
      return;
    }
    if (parseInt(this.taskDetail.order.order_check_price_is_pass) === 1) {
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteParts(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private confirmParts(val:any) {
    this.partsVisible = false;
    this.getTaskDetail();
  }

  // 添加费用处理
  // 点击费用类型input  获取费用列表  @focus
  private costItemVisibility = false;
  private isModifyOtherPrice = true;
  private priceClick() {
    if (parseInt(this.taskDetail.order.order_check_price_is_pass) === 1) {
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    this.costItemVisibility = true;
  }

  // 获取费用类表
  private getPrice() {
    if (this.costList.length === 0) {
      const params = {
        user_id: UserModule.getUserId,
        company_id: this.companyId
      };
      getPriceList(params)
        .then((res: any) => {
          this.costList = res.data.list;
        })
        .catch((err: any) => {
          this.showErrorMsg(err.msg);
        });
    }
  }
  // 费用选中 设置金额
  private selectCost(val: any) {
    this.formInformation.costValue = val.price_num;
  }

  // 添加费用
  private addCostHandle(type: any, cost: any) {
    if (!type) {
      this.showErrorMsg('请选择费用类型');
      return;
    }
    var temp = {
      price_id: type.id,
      price_name: type.price_name,
      price_num: cost
    };
    var arr = [];
    arr.push(temp);
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      price: JSON.stringify(arr)
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    addPrice(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.costItemVisibility = false;
        this.getTaskDetail();
        this.formInformation.costValue = '';
        this.formInformation.costType = '';
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 删除费用
  private removeCostHandle(val:any) {
    if (parseInt(this.taskDetail.order.order_check_price_is_pass) === 1) {
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deletePrice(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 添加故障类型
  private faultItemVisibility:any = false;
  private selectFault() {
    if (this.isDetail) {
      return
    }
    this.faultItemVisibility = true
  }
  private comfirmSelectFault(val:any) {
    this.faultItemVisibility = val;
    this.getTaskDetail();
  }
  private closeSelectFaultDialog(val:any) {
    this.faultItemVisibility = val;
  }
  private removeFaultHandle(v: any) {
    const params: any = {
      id: v.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteFault(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 备注处理
  // 添加备注 自定义 弹窗
  private inputDialogVisibility = false
  private inputDialogEnterType:number=0;
  private inputDialogContent:string=''

  private inputDialogComfirmHandle(val:string, val2:any) {
    switch (this.inputDialogEnterType) {
      case 0:
        if (isEmpty(val.trim())) {
          this.showErrorMsg('请填写备注');
          return;
        }
        this.addRemark(val, val2);
        break;
      case 1:
        this.addDiy(val, 'diy_one_content');
        break;
      case 2:
        this.addDiy(val, 'diy_two_content');
        break;
    }
  }
  private inputDialogClose(val:boolean) {
    this.inputDialogVisibility = val;
  }

  private remarkAddHandle() {
    this.inputDialogContent = '';
    this.inputDialogVisibility = true;
    this.inputDialogEnterType = 0;
  }
  private addRemark(remark:string, val:any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      remark_type: remarkType.ORDER_TASK_DISPOSE,
      remark: remark
    };
    if (val && val.id) {
      params.classify_id = val.id;
      params.classify_name = val.name;
    }
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    addRemark(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.inputDialogVisibility = false;
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 删除备注
  private removeRemarkHandle(v: any) {
    const params: any = {
      id: v.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteRemark(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }


  //工时
  private workTimeDialogVisibility = false

  private workTimeDialogComfirmHandle(val:any) {
    this.workTimeDialogVisibility = val;
    this.getTaskDetail();
  }
  private workTimeDialogClose(val:boolean) {
    this.workTimeDialogVisibility = val;
  }

  private workTimeAddHandle() {
    this.workTimeDialogVisibility = true;
  }

  private removeWorkTimeHandle(v: any) {
    const params: any = {
      work_time_id: v.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteWorkTime(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 自定义
  private diyOneAddHandle(val:number) {
    if (val === 1) {
      this.inputDialogContent = this.taskDetail.order.diy_one_content;
    } else {
      this.inputDialogContent = this.taskDetail.order.diy_two_content;
    }
    this.inputDialogVisibility = true;
    this.inputDialogEnterType = val;
  }
  private addDiy(content:string, field:string) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      edit_value: content,
      edit_field: field
    };
    if (this.taskDetail.order) {
      params.order_id = this.taskDetail.order.id;
    }
    if (this.taskDetail.order_service) {
      params.order_service_id = this.taskDetail.order_service.id;
    }
    if (this.taskDetail.order_task) {
      params.order_task_id = this.taskDetail.order_task.id;
    }
    diyContent(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.inputDialogVisibility = false;
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 添加图片成功  此处注意image_type
  private qiniu: any;
  private qiniuDomain: string = 'https://up-z1.qiniup.com';
  private form: object = {};
  private defaultUrl = '';

  // 上传图片
  private handleUploadImgSuccess(val: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      save_path: val.key,
      image_type: imageType.ORDER_TASK_IMG_DISPOSE
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    addImage(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        let msg = err.msg;
        this.showErrorMsg(err.msg);
      });
  }

  // 删除图片
  private deleteImgHandle(val: any) {
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteImage(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 上传图片准备
  private beforeUploadImg(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < limit.ORDER_SERVICE_ADD_IMAGE_MAX_SIZE;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 ' +
      limit.ORDER_SERVICE_ADD_IMAGE_MAX_SIZE + 'MB!');
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: this.companyId
    };
    return new Promise<void>((resolve, reject) => {
      resolve();
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 上传视频
  private handleUploadSuccessVideo(val: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      save_path: val.key,
      video_type: imageType.ORDER_TASK_IMG_DISPOSE
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    addVideo(params)
      .then((res: any) => {
        this.showSuccessMsg('视频上传成功');
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 删除视频
  private deleteVideoHandle(val: any) {
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteVideo(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 上传视频准备
  private beforeUploadUploadVideo(file: any) {
    const isJPG = file.type === 'video/mp4';
    const isLt2M = file.size / 1024 / 1024 < limit.ORDER_SERVICE_ADD_VIDEO_MAX_SIZE;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  mp4 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传视频大小不能超过 ' +
       limit.ORDER_SERVICE_ADD_VIDEO_MAX_SIZE + 'MB!');
    }
    return new Promise<void>((resolve, reject) => {
      resolve();
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey) + '.mp4';
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }

  // 文档
  private uploadSuccessDocument(res:any, file:any, fileList:any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      type: imageType.ORDER_TASK_IMG_DISPOSE
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    let arr = [];
    arr.push({
      original_name: file.name,
      save_path: res.key
    });
    params.document = JSON.stringify(arr);
    addWord(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private beforeUploadDocument(file:any) {
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }
  private onExceed() {
    this.$message.error('最多上传4个文档');
  }
  private onPreview(val: any){
    const url = val.full_path;
    const filename = val.original_name;
    let arr = ['pdf', 'html'];
    let nameArr = filename.split('.');
    if (arr.includes(nameArr[1])) {
      window.open(url);
    } else {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = new Blob([this.response]);
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        }
      };
      xhr.send();
    }
  }
  private onRemove(file:any, fileList:any) {
    const params: any = {
      id: file.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteWord(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 关联订单详情
  private relationDetailHandle(val: any) {
    let routeData = this.$router.resolve({
      path: '/OrderServicer/todetail',
      query: {
        order_service_id: val.order_service.id,
        company_id: val.order_service.servicer_company_id,
        showBJD: '1',
      }
    });
    window.open(routeData.href);
  }
  private imgLargeHandle(val: [], index: number, type:number) {
    if (type === 10) {
      val.forEach((element:any) => {
        element.img_url = element.full_path;
      });
    }
    if (type === 11) {
      val.forEach((element: any) => {
        element.img_url = element.url;
      });
    }
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
// 报价单--询价单
  private dataTableEnquiry: any = [];
  private handleEnquiry() {
    let p: any = {};
    p.user_id = UserModule.getUserId;
    p.user_name = UserModule.getUserName;
    p.company_id = UserModule.getCompanyId;
    p.order_id = this.taskDetail.order.id;
    p.order_service_id = this.taskDetail.order_service.id;
    p.order_task_id = this.taskDetail.order_task.id;
    getTaskEnquiry(p)
      .then((res) => {
        const data = res.data;
        if (data !== null) {
          this.dataTableEnquiry = data.list;
        } else {
          this.dataTableEnquiry = [];
        }
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }
  private getTotalCost(val: any) {
    console.log(mulNum(0.11, 4));
    let part: number = 0;
    let price: number = 0;
    let total: number = 0;
    if (val.part_list) {
      for (let m = 0; m < val.part_list.length; m++) {
        part = addNum(
          part,
          mulNum(
            val.part_list[m].parts_unit_price,
            parseInt(val.part_list[m].parts_amount)
          )
        );
      }
    }
    if (val.price_list) {
      for (let m = 0; m < val.price_list.length; m++) {
        price = addNum(price, val.price_list[m].price_num);
      }
    }
    total = addNum(part, price);
    return total.toFixed(2);
  }
  private getTotalCost1(val:any,val2:any){
    let total = addNum(val, val2);
    return total.toFixed(2);
  }
  private pdfHandle(url: any) {
    window.open(url);
  }
  private enquiryPartsTotal: any = 0;
  private enquiryPriceTotal: any = 0;
  private getEnquiryParts(param: any) {
    const { columns, data } = param;
    if (data && data.length > 0) {
      let currentPrice: Number = 0;
      // for (let t = 0; t < data.length; t++) {
      //   currentPrice += t.parts_unit_price * parseInt(t.parts_amount)
      // }
      currentPrice = data.reduce((prev: any, curr: any) => {
        
        return addNum(
          prev,
          mulNum(
            curr.parts_unit_price,
            parseInt(curr.parts_amount)
          )
        );
      }, 0);
      this.enquiryPartsTotal = currentPrice.toFixed(2);
    } else {
      this.enquiryPartsTotal = 0.0;
    }

    return [];
  }
  private getEnquiryPrice(param: any) {
    const { columns, data } = param;
    if (data && data.length > 0) {
      let currentPrice: Number = 0;
      currentPrice = data.reduce((prev: any, curr: any) => {
        return addNum(prev,curr.price_num);
      }, 0);
      this.enquiryPriceTotal = currentPrice.toFixed(2);
    } else {
      this.enquiryPriceTotal = 0.0;
    }

    return [];
  }
  private getEnquiryStr(val: any) {
    let str = "";
    switch (parseInt(val)) {
      case 1:
      case 3:
        str = "通过";
        break;
      case 5:
        str = "已通过";
        break;
      case 7:
        str = "未通过";
        break;
    }
    return str;
  }
  private judgeMoudlesInputInfo() {
    if (this.modulesHandlePer.tag.m === 1 && (!this.formInformation.tags || this.formInformation.tags.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.tag.me);
      return false;
    }
    if (this.modulesHandlePer.brand.m === 1 && (!this.formInformation.brand || this.formInformation.brand.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.brand.me);
      return false;
    }
    if (this.modulesHandlePer.device.m === 1 && (!this.formInformation.device || this.formInformation.device.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.device.me);
      return false;
    }
    if (this.modulesHandlePer.part.m === 1 && (!this.formInformation.parts || this.formInformation.parts.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.part.me);
      return false;
    }
    if (this.modulesHandlePer.img.m === 1 && (!this.formInformation.image || this.formInformation.image.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.img.me);
      return false;
    }
    if (this.modulesHandlePer.video.m === 1 && (!this.formInformation.video || this.formInformation.video.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.video.me);
      return false;
    }
    if (this.modulesHandlePer.word.m === 1 && (!this.formInformation.word || this.formInformation.word.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.word.me);
      return false;
    }
    if (this.modulesHandlePer.fee.m === 1 && (!this.dynamicCost || this.dynamicCost.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.fee.me);
      return false;
    }
    if (this.modulesHandlePer.phenomenon.m === 1 && (!this.dynamicPhenomenon || this.dynamicPhenomenon.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.phenomenon.me);
      return false;
    }
    if (this.modulesHandlePer.deviceSn.m === 1 && !this.taskDetail.order.device_sn) {
      this.showErrorMsg("请输入设备编号");
      return false;
    }
    if (this.modulesHandlePer.fault.m === 1 && (!this.dynamicFault || this.dynamicFault.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.fault.me);
      return false;
    }
    if (this.modulesHandlePer.remark.m === 1 && (!this.dynamicRemark || this.dynamicRemark.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.remark.me);
      return false;
    }
    if (this.modulesHandlePer.fixSummary.m === 1 && (!this.formInformation.fixSum || isEmpty(this.formInformation.fixSum.trim()))) {
      this.showErrorMsg(this.modulesHandlePer.fixSummary.me);
      return false;
    }
    if (this.modulesHandlePer.workTime.m === 1 && (!this.taskDetail.order_task.work_time_list || this.taskDetail.order_task.work_time_list.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.workTime.me);
      return false;
    }
    if (this.modulesHandlePer.diyOne.m === 1 && !this.taskDetail.order.diy_one_content) {
      this.showErrorMsg(this.modulesHandlePer.diyOne.me);
      return false;
    }
    if (this.modulesHandlePer.diyTwo.m === 1 && !this.taskDetail.order.diy_two_content) {
      this.showErrorMsg(this.modulesHandlePer.diyTwo.me);
      return false;
    }
    return true;
  }

  private getPartsTitle(list: any) {
    return list && list.some((item: any) => item.c_parts_name)
      ? '备件大类/名称/型号'
      : '备件名称/型号';
  }
  private isNull(val:any) {
    if (val) {
      return val;
    } else {
      return '~';
    }
  }
  private getName(val: any) {
    let st = val.split('/')
    return st[st.length - 1]
  }
  private partsInfo(val: any) {
    let str = this.isNull(val.parts_name) +
              '/' + this.isNull(val.parts_model_name) +
              '/' + this.isNull(val.parts_amount) +
              '/' + this.isNull(val.parts_unit_price) +
              '/' + this.isNull(val.parts_price) +
              '/' + this.isNull(val.parts_attribute_name);
    return str;
  }
  private back() {
    this.$router.go(-1)
  }

  private getPosition(id: any) {
    let currentId: any = document.getElementById(id);
    //  chrome
    document.body.scrollTop = currentId.offsetTop + 60;
    //  firefox
    document.documentElement.scrollTop = currentId.offsetTop + 60;
    //  safari
    window.pageYOffset = currentId.offsetTop + 60;
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
